import styled from 'styled-components'
import { useTranslation, Trans } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { fontWeights, fontSizes, colors } from '@/styles'
import { createModal } from '@/components/modalize'
import { CautionIcon, CloseIcon } from '@/components/icons'
import { toast } from '@/components/toast-notifications'
import { useModalize } from '@/components/modalize'
import { Button } from '@/components/button'

const Wrapper = styled.div`
  margin: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  width: 100%;
`

const Topper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${colors.white};
  height: auto;
  width: 100%;
  padding-top: 52px;
`

const Main = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  text-align: center;
  gap: 20px;
  max-width: 450px;
  line-height: 32px;
  padding: 8px 32px;
  background-color: ${colors.white};
`

const Title = styled.div`
  font-weight: ${fontWeights.bold};
  font-size: ${fontSizes.large};
  padding-top: 32px;
`

const Description = styled.div`
  font-weight: ${fontWeights.normal};
  line-height: 24px;
  color: ${colors.grey48};
`

const Bold = styled.span`
  font-weight: ${fontWeights.bold};
`
const StyledCloseIcon = styled(CloseIcon)`
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 20px;
`

const ButtonContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 8px;
  width: 100%;
  max-width: 370px;
  height: 44px;
  margin: 0 auto 32px;
`

const CopyConfirmationModal = ({
  name,
  address,
  applicationId,
  targetListingId,
  currentListingId,
  closeCopyModal,
  history
}) => {
  const { close } = useModalize()
  const dispatch = useDispatch()
  const onConfirmCopy = async () => {
    const { response } = await dispatch.application.confirmCopy({ targetListingId, applicationId })
    if (response?.ok) {
      toast(
        t(
          'l.application.copy_modal.success.description',
          'The application has been successfully copied to the selected listing.'
        ),
        {
          title: t('l.application.copy_modal.title', 'Application Copied Successfully!'),
          type: 'success'
        }
      )
      close()
      closeCopyModal()
      if (!window.location.href.includes('trust-score') && !window.location.href.includes('chat')) {
        history.push(`/listing/${currentListingId}/applications`)
      } else {
        history.push(`/listing/${targetListingId}`)
      }
    }
  }
  const { t } = useTranslation()
  return (
    <Wrapper>
      <StyledCloseIcon onClick={close} width={'15px'} height={'15px'} />
      <Topper>
        <CautionIcon />
      </Topper>
      <Main>
        <Title>{t('l.application.view.confirm_copy_applicant.title', 'Please note:')}</Title>
        <Description>
          <Trans
            name={name}
            address={address}
            i18nKey="l.application.view.confirm_copy_applicant_description.text"
          >
            By continuing, you agree that the applicant, <Bold>{{ name }}</Bold>, has been informed
            that their application will be copied to the listing, <Bold>{{ address }}</Bold>.
          </Trans>
        </Description>
        <ButtonContainer>
          <Button onClick={close} theme="secondary">
            {t('common.cancel', 'Cancel')}
          </Button>
          <Button onClick={onConfirmCopy}>
            {t('l.application.view.i_confirm.button', 'I Confirm')}
          </Button>
        </ButtonContainer>
      </Main>
    </Wrapper>
  )
}

export const showCopyConfirmationModal = createModal(CopyConfirmationModal, {
  width: 'auto',
  maxWidth: '440px',
  flexGrow: true,
  border: '1px solid #d8d8d8',
  tabletFullscreen: true
})
